import React, { useState, useEffect } from "react";
import "./planpagelayout.css";
import { useDispatch, useSelector } from "react-redux";
import { SelectedPayMethod, PostQuoteLife } from "../../Redux/actions/NumLife";
import { Button, Form, Checkbox } from "antd/lib";

export default function PayModeLife({ setIsModalOpen }) {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const SQQPlanMode = useSelector((state) => state?.common?.selectedLifePlan);
  const QuotePost = useSelector((state) => state?.lifedetail?.QuickQuotePost);
  const [loading, setLoading] = useState(false);
  const [selectedValue, setSelectedValue] = useState(
    SQQPlanMode ? SQQPlanMode : null
  );

  const onChange = (value) => {
    setSelectedValue(value);
    form.setFieldsValue({ payMethod: value });
  };

  const onCheckboxChange = (value) => {
    setSelectedValue(value);
    form.setFieldsValue({ payMethod: value });
  };
  // console.log('selectedValue',selectedValue)
  const onfailed = (value) => {
    console.log(value);
  };
  const onFinish = (values) => {
    console.log(values);
    setLoading(true);
    values.payMethod =
      selectedValue === "Monthly"
        ? 1002
        : selectedValue === "Quarterly"
        ? 1003
        : selectedValue === "Half Yearly"
        ? 1004
        : selectedValue === "Yearly"
        ? 1005
        : null;
    // console.log("values.payMethod", values.payMethod);
    const UpdateQQPost = {
      ...QuotePost,
      PremiumPaymentFrequency: values.payMethod,
    };
    // console.log("UpdateQQPost", UpdateQQPost);
    dispatch(PostQuoteLife(UpdateQQPost));
    setTimeout(() => {
      dispatch(SelectedPayMethod(selectedValue));
      setLoading(false);
      setIsModalOpen(false);
    }, 300);
  };
  return (
    <>
      <Form
        form={form}
        onFinish={onFinish}
        onFinishFailed={onfailed}
        layout="vertical"
        requiredMark={false}
      >
        <Form.Item
          name="payMethod"
          rules={[
            {
              required: true,
              message: "Please select Pay Method",
            },
          ]}
        >
          <div className="life-pay-edit">
            <div
              className={
                selectedValue === "Monthly"
                  ? "life-edit-Active"
                  : "life-pay-edit-rb"
              }
              onClick={() => onChange("Monthly")}
            >
              <span>
                <Checkbox
                  checked={selectedValue === "Monthly"}
                  onChange={() => onCheckboxChange("Monthly")}
                >
                  Monthly
                </Checkbox>
              </span>
            </div>
            <div
              className={
                selectedValue === "Quarterly"
                  ? "life-edit-Active"
                  : "life-pay-edit-rb"
              }
              onClick={() => onChange("Quarterly")}
            >
              <span>
                <Checkbox
                  checked={selectedValue === "Quarterly"}
                  onChange={() => onCheckboxChange("Quarterly")}
                >
                  Quarterly
                </Checkbox>
              </span>
            </div>
            <div
              className={
                selectedValue === "Half Yearly"
                  ? "life-edit-Active"
                  : "life-pay-edit-rb"
              }
              onClick={() => onChange("Half Yearly")}
            >
              <span>
                <Checkbox
                  checked={selectedValue === "Half Yearly"}
                  onChange={() => onCheckboxChange("Half Yearly")}
                >
                  Half-Yearly
                </Checkbox>
              </span>
            </div>
            <div
              className={
                selectedValue === "Yearly"
                  ? "life-edit-Active"
                  : "life-pay-edit-rb"
              }
              onClick={() => onChange("Yearly")}
            >
              <span>
                <Checkbox
                  checked={selectedValue === "Yearly"}
                  onChange={() => onCheckboxChange("Yearly")}
                >
                  Yearly
                </Checkbox>
              </span>
            </div>
          </div>
        </Form.Item>
        <Form.Item style={{ textAlign: "center" }}>
          <Button
            type="primary"
            htmlType="submit"
            className="update-qut-button"
            loading={loading}
          >
            Update
          </Button>
        </Form.Item>
      </Form>
    </>
  );
}
